import store from "../../setup/redux/Store";
import { DECIMALS } from "../constants/common";
import {IAgentProduct} from "../models/AgentProduct";
import { roundNumber } from "../modules/common/helper";

const getReceiveDiscount = (item: IAgentProduct, isRound = true) => {
  if (!item) {
    return 0;
  }
  const {market_price: marketPrice, sale_price: price} = item
  if (!marketPrice) {
    return 0;
  }
  const result = (marketPrice - price) / marketPrice * 100;
  const state = store.getState();
  const config = state.auth.user?.store?.open_store_config;
  const decimals = DECIMALS[config?.number_format ?? 'default'] ?? 0;

  return isRound ? roundNumber(result, decimals) : result;
}
export default getReceiveDiscount;